export default __webpack_public_path__ + "155f69e272569f118a6ae78492e87483.png";